import { fg } from '@atlassian/jira-feature-gating';

const JiraAiFetchApptypeForUserAssigneeRelayProvider = {
	get(): boolean {
		return fg('jira_ai_fetch_apptype_for_user_assignee');
	},
};

export default JiraAiFetchApptypeForUserAssigneeRelayProvider;
